import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

const AdminPage = lazy(() => import("@/pages/admin/AdminPage"));
const SubscriptionPlanCreatePage = lazy(() => import("@/pages/admin/subscription-plans/SubscriptionPlanCreatePage"));
const SubscriptionPlanEditPage = lazy(() => import("@/pages/admin/subscription-plans/SubscriptionPlanEditPage"));
const SubscriptionPlansListPage = lazy(() => import("@/pages/admin/subscription-plans/SubscriptionPlansListPage"));

export function AdminRoutes() {
  return (
    <>
      <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
      <Route path="/admin/subscription-plans" element={<ProtectedRoute><SubscriptionPlansListPage /></ProtectedRoute>} />
      <Route path="/admin/subscription-plans/new" element={<ProtectedRoute><SubscriptionPlanCreatePage /></ProtectedRoute>} />
      <Route path="/admin/subscription-plans/:planId/edit" element={<ProtectedRoute><SubscriptionPlanEditPage /></ProtectedRoute>} />
    </>
  );
}
